import { Grid, Spinner } from '@design-systems/canvas-ui'
import styles from './LoadingPage.module.css'

const LoadingPage = () => {
  return (
    <Grid.Container
      className={styles.container}
      align="center"
      justify="center"
      direction="column"
    >
      <Grid.Item>
        <Spinner />
      </Grid.Item>
    </Grid.Container>
  )
}

export default LoadingPage
